import { 
  UserGroupIcon, 
  ChartBarIcon, 
  GlobeAltIcon,
  BuildingOfficeIcon 
} from '@heroicons/react/24/outline';
import Stats from "../components/home/Stats";


const process = [
  {
    title: 'Import Listings',
    description: 'Seamlessly import your product catalog through our API or dashboard',
    icon: ChartBarIcon
  },
  {
    title: 'Localize & Distribute',
    description: 'Automatic translation and cultural adaptation for MENAP markets',
    icon: GlobeAltIcon
  },
  {
    title: 'Manage Operations',
    description: 'End-to-end logistics and payment processing across all channels',
    icon: BuildingOfficeIcon
  }
];

const team = [
  {
    name: 'Salim Rennewi',
    role: 'CEO & Co-Founder',
    bio: 'Leading the vision and strategy for SellAbroad\'s expansion across MENAP',
    icon: UserGroupIcon
  },
  {
    name: 'Nader Edward',
    role: 'COO & Co-Founder',
    bio: 'Driving operational excellence and marketplace partnerships',
    icon: UserGroupIcon
  }
];

function About() {
  return (
    <div className="bg-white">
      {/* Mission Section */}
      <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-base font-semibold text-[#0049ac] tracking-wide uppercase">Our Mission</h2>
          <p className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">
            Simplifying MENAP Expansion
          </p>
          <p className="max-w-xl mt-5 mx-auto text-xl text-gray-500">
            We're building the infrastructure for global brands to seamlessly expand into the Middle East, North Africa, and Pakistan.
          </p>
        </div>
      </div>

      {/* How It Works Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-base text-[#0049ac] font-semibold tracking-wide uppercase font-poppins">How It Works</h2>
            <p className="mt-2 text-3xl leading-8 font-bold tracking-tight text-gray-900 sm:text-4xl font-poppins">
              Three Steps to MENAP Success
            </p>
          </div>

          <div className="mt-20">
            <div className="flex flex-col lg:flex-row gap-8 justify-between">
              {process.map((step) => (
                <div key={step.title} className="flex-1 bg-gray-100 rounded-lg p-8 shadow-sm hover:shadow-md hover:scale-105 transform transition-all duration-300">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-[#0049ac] text-white mb-6">
                    <step.icon className="h-6 w-6" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 font-poppins">{step.title}</h3>
                  <p className="mt-2 text-base text-gray-600 font-inter">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <Stats />

      {/* Team Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-base text-[#0049ac] font-semibold tracking-wide uppercase font-poppins">Our Team</h2>
            <p className="mt-2 text-3xl leading-8 font-bold tracking-tight text-gray-900 sm:text-4xl font-poppins">
              Led by Industry Experts
            </p>
          </div>

          <div className="mt-20">
            <div className="flex flex-col lg:flex-row gap-8 justify-between">
              {team.map((member) => (
                <div key={member.name} className="flex-1 bg-gray-100 rounded-lg p-8 shadow-sm hover:shadow-md hover:scale-105 transform transition-all duration-300">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-[#0049ac] text-white mb-6">
                    <member.icon className="h-6 w-6" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 font-poppins">{member.name}</h3>
                  <p className="text-sm text-[#0049ac] mt-1">{member.role}</p>
                  <p className="mt-4 text-base text-gray-600 font-inter">{member.bio}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;